import { Observable } from 'rxjs';
import { UseCase } from '@/core/base/use-case';
import { Insurance } from '../models/insurance.model';
import { InsuranceRepository } from '../repositories/insurance.repository';

export class ToggleInsuranceUseCase implements UseCase<void, Insurance> {
    constructor(private insuranceRepository: InsuranceRepository) {}

    execute(): Observable<Insurance> {
        return this.insuranceRepository.toggleInsurance();
    }
}
